import React from 'react';
import { StopOutlined } from '@ant-design/icons';
import AppModal from '@/pages/inside/tenant/AppModal';
import Markdown from '@/components/ui/Markdown';
import DiscussionPanel from '@/components/module/projects/discussion/DiscussionPanel';
import { Container } from '@/components/ui/Container';
import {
    CreateRoleModalBody,
    ModalChromeHeading,
    ModalBlockLabel,
    MutedText,
    CardDescriptionInner,
    CardDescriptionWrap,
    SectionBadgeBlocker,
    ColumnBlockHeaderLeft,
    SprintBoardCardTitleRow,
} from '@/pages/inside/tenant/style';
import { getBlockerDescriptionMarkdown, getBlockerDisplayId } from '@hooks/projects/projectHelpers';

/**
 * Blockers tab: blocker detail + discussion (replaces side panel).
 */
export default function BlockerDetailModal({
    projectId,
    blocker,
    discussions,
    discussionsLoading,
    createPost,
    createPostPending,
    editPost,
    editPostPending,
    deletePost,
    deletePostPending,
    onClose,
}) {
    const open = Boolean(blocker);
    const title = blocker ? (
        <Container $display="flex" $flexDirection="column" $gap="6px">
            <MutedText style={{ fontSize: 12, margin: 0 }}>{getBlockerDisplayId(blocker)}</MutedText>
            <SprintBoardCardTitleRow style={{ alignItems: 'center', marginBottom: 0 }}>
                <ColumnBlockHeaderLeft style={{ flex: 1, minWidth: 0 }}>
                    <SectionBadgeBlocker>Blocker</SectionBadgeBlocker>
                    <ModalChromeHeading style={{ fontSize: 20, marginTop: 4 }}>
                        {blocker.title || blocker.name || 'Blocker'}
                    </ModalChromeHeading>
                </ColumnBlockHeaderLeft>
            </SprintBoardCardTitleRow>
        </Container>
    ) : null;

    const descriptionMd = blocker ? getBlockerDescriptionMarkdown(blocker) : '';

    return (
        <AppModal size="lg" open={open} onCancel={onClose} title={title} footer={null}>
            {open && blocker && (
                <CreateRoleModalBody $flush $noMaxHeight>
                    <Container $display="flex" $flexDirection="column" $gap="20px">
                        <div>
                            <ModalBlockLabel as="div" style={{ display: 'block', marginBottom: 8 }}>
                                Description
                            </ModalBlockLabel>
                            {descriptionMd ? (
                                <CardDescriptionWrap>
                                    <Markdown source={descriptionMd} component={CardDescriptionInner} emptyFallback="—" />
                                </CardDescriptionWrap>
                            ) : (
                                <MutedText style={{ margin: 0 }}>No description.</MutedText>
                            )}
                        </div>
                        <section style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                            <DiscussionPanel
                                projectId={projectId}
                                discussions={discussions}
                                isLoading={discussionsLoading}
                                createPost={createPost}
                                createPostPending={createPostPending}
                                editPost={editPost}
                                editPostPending={editPostPending}
                                deletePost={deletePost}
                                deletePostPending={deletePostPending}
                                sectionLabel="Discussion"
                                emptyIcon={<StopOutlined />}
                                emptyTitle="No discussion yet"
                                emptyDesc="Add a comment below."
                                listStyle={{ flex: 1, minHeight: 160 }}
                            />
                        </section>
                    </Container>
                </CreateRoleModalBody>
            )}
        </AppModal>
    );
}
